import { Injectable } from '@angular/core';
import {BehaviorSubject, Observable, of} from "rxjs";
import {UserDataApi} from "../api/user-data.api";
import {KlasifikatoriusApi} from "../api/klasifikatorius.api";

@Injectable({
  providedIn: 'root',
})
export class SharedDataService {
  private klaidos: any;
  private sessionExpiredSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  private sessionTimeout: any;
  private isLoadingSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  private userData!: UserDataApi;
  private klasifikatoriusApiSubject: BehaviorSubject<KlasifikatoriusApi[]> = new BehaviorSubject<KlasifikatoriusApi[]>([]);

  getklasifikatoriusApiSubject(): Observable<KlasifikatoriusApi[]> {
    return this.klasifikatoriusApiSubject.asObservable();
  }

  setklasifikatoriusApiSubject(data: KlasifikatoriusApi[]): void {
    this.klasifikatoriusApiSubject.next(data);
  }

  setKlaidos(klaidos: any) {
    this.klaidos = klaidos;
  }

  getKlaidos(): any {
    return this.klaidos;
  }

  getSessionExpired(): Observable<boolean> {
    return this.sessionExpiredSubject.asObservable();
  }

  setSessionExpired(value: boolean): void {
    this.sessionExpiredSubject.next(value);
  }

  getSessionTimeout(): number {
    return this.sessionTimeout
  }

  setSessionTimeout(timeout: any) {
    this.sessionTimeout = timeout;
  }

  setIsLoading(loading: boolean): void {
    this.isLoadingSubject.next(loading);
  }

  getIsLoading(): Observable<boolean> {
    return this.isLoadingSubject.asObservable();
  }

  setUserData(userData: any) {
    this.userData = userData;
  }

  getUserData(): any {
    return this.userData;
  }
}
